import { readBarcodesFromImageData } from 'zxing-wasm';

export const readBarcode = async (imageData: ImageData) => {
	if ('BarcodeDetector' in globalThis) {
		const builtInBarcodeDetector = new BarcodeDetector({
			formats: ['qr_code'],
		});

		const result = (await builtInBarcodeDetector?.detect(imageData)) ?? [];
		return result.map((symbol) => ({
			typeName: symbol.format,
			data: symbol.rawValue,
		}));
	}

	const result = await readBarcodesFromImageData(imageData);
	return result.map((symbol) => ({
		typeName: symbol.format,
		data: symbol.text,
	}));
};
